import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { FeatureFlagsDto } from '../interfaces/feature-flags-dto';

@Injectable({
    providedIn: 'root'
})
export class FeaturesService {
    private readonly http = inject(HttpClient);


    private readonly baseUrl = environment.apiUrl + '/api/v1/features';
    private featureFlags$?: Observable<FeatureFlagsDto>;

    getFeatureFlags(): Observable<FeatureFlagsDto> {
        if (!this.featureFlags$) {
            this.featureFlags$ = this.http.get<FeatureFlagsDto>(this.baseUrl).pipe(shareReplay(1));
        }
        return this.featureFlags$;
    }
}
